import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import Loader from 'cccisd-loader';
import Tabs from 'cccisd-tabs';
import { client } from 'cccisd-apollo';
import StudentTab from './StudentTab';
import PeerNomTab from './PeerNomTab';
import ClimateTab from './ClimateTab';
import NominationsTab from './NominationsTab';
import query from './query.graphql';
import style from './style.css';

function Administrative() {
    const [isLoading, setIsLoading] = useState(true);
    const [classesWithNoAp, setClassesWithNoAp] = useState([]);
    const [currTimepoint, setCurrTimepoint] = useState(1);
    const [timepointOptions, setTimepointOptions] = useState([]);
    const [isPnTab, setIsPnTab] = useState(false);
    const [isClimateTab, setIsClimateTab] = useState(false);

    useEffect(() => {
        async function getTabsData() {
            setIsLoading(true);

            const resp = await client.query({ query });
            const classes = _get(resp, 'data.groups.classList', []) || [];
            const selectedAps = [];
            const classWithNoAp = [];
            classes.forEach(c => {
                const ap = _get(c, 'selectedAssignmentPlan', null);
                if (!ap || !Array.isArray(ap.sessionList) || ap.sessionList.length <= 0) {
                    const label = _get(c, 'group.label', 'Unnamed');
                    classWithNoAp.push(label);
                }

                selectedAps.push(ap);
            });

            setClassesWithNoAp(classWithNoAp);

            let showPnTab = false;
            let showClimateTab = false;
            let timepoints = {}; // map of { <int>: <boolean> }
            selectedAps.forEach(ap => {
                ap.sessionList.forEach(session => {
                    const tp = session.timepoint;
                    if (!tp) {
                        console.error('No timepoint found for assignment session ' + session.sessionId);
                        return;
                    }

                    const surveyHandles = Array.isArray(session?.settings?.options) ? session.settings.options : [];
                    if (surveyHandles.length <= 0) {
                        console.error('No options selected for assignment session ' + session.sessionId);
                        return;
                    }

                    surveyHandles.forEach(surveyHandle => {
                        if (surveyHandle === 'climate') {
                            showClimateTab = true;
                        } else if (surveyHandle.startsWith('pn')) {
                            showPnTab = true;
                        }
                    });
                    timepoints[tp] = true;
                });
            });

            setIsPnTab(showPnTab);
            setIsClimateTab(showClimateTab);
            setTimepointOptions(Object.keys(timepoints).map(tp => parseInt(tp, 10)));
            setIsLoading(false);
        }

        getTabsData();
    }, []);

    function renderTimepointPills() {
        return (
            timepointOptions.length >= 1 && (
                <div className={`btn-group ${style.pillButtons}`} role="group">
                    {timepointOptions
                        .sort((a, b) => a - b)
                        .map(timepoint => (
                            <button
                                key={timepoint}
                                type="button"
                                className={`btn ${currTimepoint === timepoint ? 'btn-primary' : 'btn-secondary'}`}
                                onClick={() => setCurrTimepoint(timepoint)}
                            >
                                Time {timepoint}
                            </button>
                        ))}
                </div>
            )
        );
    }

    function renderStudentTab() {
        return {
            name: 'Students',
            title: 'Students',
            content: <StudentTab renderTimepointPills={renderTimepointPills} currTimepoint={currTimepoint} />,
        };
    }

    function renderPnTab() {
        return {
            name: 'Networker',
            title: 'Networker',
            content: <PeerNomTab renderTimepointPills={renderTimepointPills} currTimepoint={currTimepoint} />,
        };
    }

    function renderNominationsTab() {
        return {
            name: 'Nominations',
            title: 'Nominations',
            content: <NominationsTab timepointOptions={timepointOptions} />,
        };
    }

    function renderClimateTab() {
        return {
            name: 'Climate',
            title: 'Climate',
            content: <ClimateTab renderTimepointPills={renderTimepointPills} currTimepoint={currTimepoint} />,
        };
    }

    let tabList = [renderStudentTab()];
    if (isPnTab) {
        tabList.push(renderPnTab());
        tabList.push(renderNominationsTab());
    }
    if (isClimateTab) {
        tabList.push(renderClimateTab());
    }

    return (
        <Loader loading={isLoading}>
            {classesWithNoAp.length > 0 && (
                <div className="alert alert-warning">
                    <p className="text-warning-emphasis mb-0">
                        There are {classesWithNoAp.length} Classes that have no assignment plan. Contact an
                        administrator to make sure every student has an assessment.
                    </p>
                </div>
            )}
            {tabList.length > 0 && <Tabs tabList={tabList} />}
        </Loader>
    );
}

export default Administrative;
